<div class="dialog" role="document" aria-labelledby="assign-role-title">
  <div class="dialog-header">
    <span class="dialog-title" id="assign-role-title">Add role — {{ data.name }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" novalidate (ngSubmit)="submit()">
    <div class="field">
      <label class="field-label" id="assign-role-est-label">Establishment <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="assign-role-est-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          formControlName="establishmentId"
          placeholder="Select establishment"
        >
          @if(showCentral){
          <mat-option [value]="centralPlaceId">Central (no establishment)</mat-option>
          }
          @if(showEstablishments){
          @for(e of establishments; track e.establishmentId){
          <mat-option [value]="e.establishmentId">{{ e.name }}</mat-option>
          }
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="field-label" id="assign-role-role-label">Role <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="assign-role-role-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          formControlName="roleKey"
          placeholder="Select role"
          (selectionChange)="onRoleChange()"
        >
          @for(r of roles; track r.roleId){
          <mat-option [value]="r.roleKey">{{ r.roleName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if(!isLoading && roles.length === 0){
      <span class="hint">No roles are available to assign.</span>
      }
    </div>

    <div class="field">
      <label class="field-label" for="assign-role-valid-until">Access valid until {{ isVolunteer ? '*' : '(optional)' }}</label>
      <input id="assign-role-valid-until" type="date" class="text-box-active" formControlName="validUntil" />
    </div>

    <div class="dialog-actions">
      <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading || form.invalid">Assign</button>
    </div>
  </form>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
